/* eslint-disable @typescript-eslint/no-explicit-any */
import { useState, useEffect } from 'react';
import DropdownSelect from './DropdownSelect';
import { supabase } from '../../lib/supabase';

export function CountrySelect({
  onChange,
  value,
  full,
}: {
  onChange: (val: number | string | string[] | boolean | undefined) => void;
  value: string;
  full?: boolean;
}) {
  const [countries, setCountries] = useState<any[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchCountries = async () => {
      setLoading(true);
      const { data, error } = await supabase
        .from('countries')
        .select('id, name, code, region')
        .order('name', { ascending: true });

      if (error) {
        console.error('Error fetching countries:', error);
        setCountries([]);
      } else {
        setCountries(data ?? []);
      }

      setLoading(false);
    };

    fetchCountries();
  }, []); // Empty dependency array → runs only once

  if (loading || !countries.length) return null;

  return (
    <DropdownSelect
      options={countries.map((c: { id: any; name: any; code: any }) => ({
        id: c.code,
        label: c.name,
      }))}
      selectedIds={value}
      placeholder="Select"
      full={full}
      // @ts-expect-error: ts(2339)
      onValueChanged={(val) => onChange(val.id)}
    />
  );
}
